import React, { FC, useEffect, useState } from "react";
import DndItems from "./DndItems";
import classes from "./DndArea.module.scss";
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
  MouseSensor,
  TouchSensor,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  rectSortingStrategy,
} from "@dnd-kit/sortable";
import { backgroundColorDnd } from "../../commons/colors";
import { useRecoilValue } from "recoil";
import { userState } from "../../states/userState";
type localColumn = {
  [key: string]: boolean;
};
type Props = {
  localColumns: localColumn[];
  setLocalColumns: React.Dispatch<React.SetStateAction<localColumn[]>>;
  isShowAll: boolean;
};

const DndArea: FC<Props> = (props) => {
  const { localColumns, setLocalColumns, isShowAll } = props;
  const [dndColumns, setDndColums] = useState<localColumn[]>(localColumns);
  const [dndIdentifer, setDndIdentifer] = useState<string[]>(
    dndColumns.map((column) => Object.keys(column)[0])
  );
  const user = useRecoilValue(userState);
  // useEffect(() => {}, [dndColumns]);
  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 2 } }),
    useSensor(TouchSensor, { activationConstraint: { distance: 2 } }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    }),
    useSensor(MouseSensor, { activationConstraint: { distance: 2 } })
  );
  const handleDndItemsClick = (column: localColumn) => {
    // console.log("DndItemsがクリックされました", column);
    const key = Object.keys(column)[0];
    const newVisiblity = !column[key];
    const updatedColumns = localColumns.map((column) => {
      if (column.hasOwnProperty(key)) {
        return { [key]: newVisiblity };
      }
      return column;
    });
    setLocalColumns(updatedColumns);
  };

  useEffect(() => {
    if (!isShowAll) {
      const newColumns = localColumns.filter((column) => {
        const key = Object.keys(column)[0];
        return column[key];
      });
      // setDndColums(newColumns);
      setDndColums(localColumns);
      setDndIdentifer(newColumns.map((column) => Object.keys(column)[0]));
    } else {
      setDndColums(localColumns);
      setDndIdentifer(localColumns.map((column) => Object.keys(column)[0]));
    }
    // console.log("Dnd確認isShowAll", isShowAll);
  }, [isShowAll, localColumns]);

  // useEffect(() => {
  //   console.log("Dnd確認dndIdentifer", dndIdentifer, dndColumns, localColumns);
  // }, [dndIdentifer]);

  //ドラッグが終了した時に実行
  const handleDragEnd = (event: any) => {
    const { active, over } = event;
    if (over && active.id !== over.id) {
      //Identiferの順番を変更
      const oldIndex = dndIdentifer.indexOf(active.id);
      const newIndex = dndIdentifer.indexOf(over.id);
      const newIdentifer = arrayMove(dndIdentifer, oldIndex, newIndex);

      //dndColumnsの順番を変更
      let newDndColumns: localColumn[] = [];
      if (isShowAll) {
        newDndColumns = newIdentifer
          .map((ident) =>
            localColumns.find((column) => column.hasOwnProperty(ident))
          )
          .filter((column): column is localColumn => column !== undefined);
      } else {
        newDndColumns = sortDndColumns(newIdentifer, dndColumns);
      }

      setDndIdentifer(newIdentifer);
      setDndColums(newDndColumns);
      setLocalColumns(newDndColumns);
    }
  };

  const getColumn = (id: string): localColumn => {
    const column = dndColumns.find((column) => column.hasOwnProperty(id));
    return column ?? { 無し: false };
  };

  const sortDndColumns = (
    columnsIdentifer: string[],
    dndColumns: localColumn[]
  ): localColumn[] => {
    // columnsIdentiferに基づいてvalueがtrueの項目を並び替え
    const orderedTrueColumns = columnsIdentifer
      .map((id) =>
        dndColumns.find(
          (column) => column.hasOwnProperty(id) && column[id] === true
        )
      )
      .filter((column) => column !== undefined) as localColumn[];

    // valueがfalseの項目を保持
    const falseColumns = dndColumns.filter(
      (column) => Object.values(column)[0] === false
    );

    // 並び替えたtrueの項目と変更しないfalseの項目を結合
    return [...orderedTrueColumns, ...falseColumns];
  };

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragEnd={handleDragEnd}
    >
      <SortableContext items={dndIdentifer} strategy={rectSortingStrategy}>
        <div
          className={classes.dndArea}
          style={backgroundColorDnd(user?.mode ?? "lite")}
        >
          {dndIdentifer.map((id, index) => (
            <DndItems
              key={id}
              // key={id}
              onClick={() => handleDndItemsClick(getColumn(id))}
              id={id}
              // id={id}
              column={getColumn(id)}
            />
          ))}
        </div>
      </SortableContext>
    </DndContext>
  );
};

export default DndArea;

// identifer = ["レコード番号","名前","年齢","住所","電話番号","メールアドレス","備考"];
// localColumns = [{備考:true},{レコード番号:true},{名前:true},{年齢:true},{住所:true},{電話番号:true},{メールアドレス:true}];
